var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-dropdown",
        {
          attrs: { trigger: ["click"] },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "overlay" }, slot: "overlay" },
            [
              _c(
                "a-spin",
                { attrs: { spinning: _vm.loading } },
                [
                  _c(
                    "a-tabs",
                    {
                      staticClass: "dropdown-tabs",
                      style: { width: "297px" },
                      attrs: { tabBarStyle: { textAlign: "center" } },
                    },
                    [
                      _c(
                        "a-tab-pane",
                        { key: "1", attrs: { tab: "消息提醒" } },
                        [
                          _c(
                            "a-list",
                            { staticClass: "tab-pane" },
                            _vm._l(_vm.noticeList, function (item, i) {
                              return _c(
                                "a-list-item",
                                { key: i },
                                [
                                  _c("a-list-item-meta", {
                                    attrs: {
                                      title: item.objTypeName,
                                      description: item.taskContent,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.taskPromptDetail(item)
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { staticClass: "header-notice", on: { click: _vm.fetchNotice } },
            [
              _c(
                "a-badge",
                {
                  staticClass: "notice-badge",
                  attrs: { count: _vm.noticeCount },
                },
                [
                  _c("a-icon", {
                    class: ["header-notice-icon"],
                    style: { color: "#000" },
                    attrs: { type: "bell" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "管理",
            centered: "",
            closable: false,
            footer: null,
            maskClosable: false,
            visible: _vm.editModalVisible,
            width: 1200,
          },
        },
        [
          _c(_vm.componentName, {
            ref: "detailForm",
            tag: "component",
            attrs: { rowId: _vm.id },
            on: {
              cancelled: function ($event) {
                _vm.editModalVisible = false
              },
              saved: function ($event) {
                _vm.editModalVisible = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }